export abstract class AppConstants {
    public static readonly dataStoreCurrentClub = 'session.currentClub.';
    public static readonly dataStoreCurrentVereinId = 'session.currentClub.Id';
    public static readonly dataStoreCurrentClubName = 'session.currentClub.Name';
    public static readonly dataStoreCurrentAnlass = 'session.currentAnlass.';
    public static readonly dataStoreCurrentAnlassId = 'session.currentAnlass.Id';
    public static readonly dataStoreCurrentAnlassName = 'session.currentAnlass.Name';
    public static readonly dataStoreUrlQueryParameters = 'local.urlQueryParameters.';
    public static readonly specialValueCurrentPersonId =  'specialValue.currentPerson.id';
}
